import * as Linking from 'expo-linking';

import { getInitialUrlWithoutFeatureFlagsOverrides } from '@order/LaunchDarkly';

import type { AppLinkingOptions } from './AppNavigation.props';

/**
 * NOTE: Before updating screen paths, please check related components and
 *       hooks (such as the quick action handler).
 */
export const appNavigationLinking: AppLinkingOptions = {
  getInitialURL: getInitialUrlWithoutFeatureFlagsOverrides,
  prefixes: [
    Linking.createURL('/', { scheme: 'sweetgreen-order' }),
    'https://*.sweetgreen.com',
    'https://sweetgreen.com',
    'order://',
  ],
  config: {
    initialRouteName: 'MainTabs',
    screens: {
      MainTabs: {
        screens: {
          HomeTab: {
            screens: {
              Home: { path: '', exact: true },
            },
          },
          MenuTab: {
            screens: {
              Locations: { path: 'locations', exact: true },

              // A "placeholder" route that will always redirect users to the
              // menu or delivery menu route if the location slug or address ID
              // is available, or to the location selection route if it is not.
              MenuWithoutSlug: { path: 'menu', exact: true },

              Menu: { path: ':restaurantSlug/menu', exact: true },
              DeliveryMenu: {
                path: 'delivery/:addressId/menu',
                exact: true,
              },
            },
          },
          LoyaltyTab: {
            screens: {
              LoyaltyHome: { path: 'sg-rewards', exact: true },
            },
          },
          ReorderTab: {
            screens: {
              Reorder: { path: 'reorder-tab', exact: true },
            },
          },
          AccountTab: {
            screens: {
              AccountMenu: { path: 'account/menu', exact: true },
              Profile: { path: 'account/info', exact: true },
              CreditAndPromoCodes: {
                path: 'account/credit-and-promo-codes',
                exact: true,
              },
              PaymentAndGiftCards: {
                path: 'account/payment-and-gift-cards',
                exact: true,
              },
              GiftCards: {
                path: 'account/gift-cards/:giftCardId?',
                exact: true,
              },
              Addresses: { path: 'account/addresses', exact: true },
              Orders: { path: 'account/orders/:tabId?', exact: true },
              Favorites: { path: 'account/favorites', exact: true },
              Notifications: { path: 'account/notifications', exact: true },
              AccountDietaryRestrictions: {
                path: 'account/dietary-restrictions',
                exact: true,
              },
            },
          },
          GiftCardsTab: {
            screens: {
              GiftCards: {
                path: 'gift',
                exact: true,
              },
              GiftCardCheckout: {
                path: '/gift/checkout/:assetId',
                exact: true,
              },
              GiftCardConfirmation: {
                path: '/gift/confirmation/:orderId',
                exact: true,
              },
              GiftCardRedemption: {
                path: '/gift/redeem/:giftCardId',
                exact: true,
              },
            },
          },
        },
      },
      Modal: {
        screens: {
          Customization: {
            path: ':restaurantSlug/:productSlug/:ingredientIds?/:name?',
            exact: true,
          },
          CustomizationEdit: {
            path: ':restaurantSlug/:productSlug/edit/:lineItemId',
            exact: true,
          },
          CustomizationDelivery: {
            path: 'delivery/:addressId/:productSlug/:ingredientIds?/:name?',
            exact: true,
          },
          CustomizationDeliveryEdit: {
            path: 'delivery/:addressId/:productSlug/edit/:lineItemId',
            exact: true,
          },

          ProductDetails: {
            path: 'product-details/:baseProductSlug',
            exact: true,
          },
          ProductDetailsLocation: {
            path: 'product-details/:baseProductSlug/change-location',
            exact: true,
          },

          UpsellScreen: {},
          Payments: { path: 'payments' },

          DeliveryOrderInFlight: {},

          Reorder: { path: 'reorder', exact: true },
          ReorderConfirmLocation: {},
          ReorderChangeLocation: {},
          ReorderConflictReview: {},
          ReorderActiveBagWarning: {},

          PersonalData: { path: 'ca-data-requests', exact: true },
          PersonalDataDetails: {},

          Bag: {},
          PostOrder: { path: 'post-order', exact: true },
          Chat: { path: 'chat', exact: true },

          OrderStatus: { path: 'order-status/:orderId', exact: true },

          CreditAndPromoCodes: {
            path: 'credit-and-promo-codes',
            exact: true,
          },

          CreditAdd: {
            path: 'credit/add',
            exact: true,
          },
          CreditScan: {
            path: 'credit/scan',
            exact: true,
          },
          CreditDetails: {
            path: 'credit',
            exact: true,
          },
          AddGiftCard: {
            path: 'add-gift-card/:giftCardId?',
            exact: true,
          },
          RedeemGiftCard: {
            path: 'redeem-gift-card/:giftCardId?',
            exact: true,
          },

          DietaryRestrictions: {
            path: 'dietary-restrictions',
            exact: true,
          },
          RateOrder: { path: 'feedback/:orderId', exact: true },
          ShareLineItem: { path: 'share/:lineItemSlug', exact: true },

          ScanAtCheckout: { path: 'scan-at-checkout', exact: true },
          ForgotToScan: { path: 'forgot-to-scan', exact: true },

          OrderProductConfirmProduct: {
            path: '/order-product/:productSlug',
            exact: true,
          },
          OrderProductConfirmLocation: {
            path: '/order-product/:productSlug/confirm-location',
            exact: true,
          },
          OrderProductSearchLocation: {
            path: '/order-product/:productSlug/search-location',
            exact: true,
          },
        },
      },
      Auth: {
        screens: {
          JoinOrSignIn: { path: 'join-or-sign-in', exact: true },
          Login: { path: 'login', exact: true },
          Join: { path: 'join', exact: true },
        },
      },
      Error: {
        screens: {
          NotFoundWithRestaurantSlug: { path: ':restaurantSlug', exact: true },
          NotFound: { path: '*' },
        },
      },
    },
  },
};
